import React, { useState } from "react";
import { Button, FormControl, TextField, Box, Typography, Paper,  } from '@mui/material';
import LoadingScreen from '../../../components/LoadingScreen'
import { useParams, useNavigate } from "react-router-dom";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../../utils/hooks';

// const LoadingScreen = ({ open }) => (
//     <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
//         <CircularProgress color="inherit" />
//     </Backdrop>
// );

function EditRobotVersion(props) {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [, setRobots] = useState([])
  const [version, setVersion] = useState({});
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchRobotData(0),
        apiConfig.fetchRobotVersion(id)
    ]).then(results => {
        console.log(results[0])
        setRobots(results[0].RobotResponse)
        console.log(results[1])
        setVersion(results[1].RobotResponse)
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  const handleSave = () => {
    // console.log(software)
    setLoading(true);
    Promise.all([
        apiConfig.updateRobotVersion(version.Id, version),
    ]).then(results => {
        // setTimeout(() => {
        console.log(results[0])
        setLoading(false);
        navigate("/managements/robot_version_management");
        // }, 5000);
    }).catch(error => {
        console.error(error);
    });
  }

  const handleVersionChanges = (e) => {
    const { name, value } = e.target;
    setVersion(prevState => ({ ...prevState, [name]: value }));
    setVersion(prevState => ({ ...prevState, "UpdatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
  };

  const handleCancel = () => {
    setLoading(false)
    setRobots([])
    setVersion({})
    navigate("/managements/robot_version_management");
  }

  return (
    <Box p={2}>
    <LoadingScreen open={loading} />
      <Typography variant="h4">Edit Robot Version {version.Version}</Typography>
      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
                fullWidth
                label="Robot Version"
                name="Version"
                variant="outlined"
                value={version.Version}
                InputLabelProps={{ shrink: true }}
                onChange={handleVersionChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Description"
                name="Description"
                variant="outlined"
                value={version.Description}
                InputLabelProps={{ shrink: true }}
                onChange={handleVersionChanges}
                sx={{ mb: 2 }}
            />
          </FormControl>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
          <Button variant="contained" color="primary" type="button" onClick={handleCancel}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default EditRobotVersion;
